export default "__VITE_ASSET__bcd63ef4__"